module.exports = __webpack_public_path__ + "img/icon-competence-9.f856f014.svg";